import { Flex, Tag } from "antd"
import { ColumnsType } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { ChargeResponse } from "@src/shared/api/generated"
import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"
import { dateTimeFormat } from "@src/shared/date"
import { parsePricing, Pricing } from "@src/shared/parsePricing"

export const statusOptions = [
  { label: "new", value: "new" },
  { label: "pending", value: "pending" },
  { label: "completed", value: "completed" },
  { label: "expired", value: "expired" },
  { label: "unresolved", value: "unresolved" },
  { label: "resolving", value: "resolving" },
  { label: "resolved", value: "resolved" },
  { label: "canceled", value: "canceled" },
]
export const filterFields = [
  getFilterSimpleFiled("date").date({ col: 6, label: "Date" }),
  getFilterSimpleFiled("status").select(statusOptions, {
    col: 6,
    placeholder: filtersPresets.status.placeholder,
  }),
  getFilterSimpleFiled("externalId").search({
    col: 6,
    label: "External ID",
    placeholder: "Search by External ID",
  }),
  getFilterSimpleFiled("projectId").search({
    col: 6,
    label: "Project ID",
    placeholder: "Search by Project ID",
  }),
]
